import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import bvt1 from '../assets/bvt1.jpg';
import bvt2 from '../assets/bvt2.jpg';
import bvt3 from '../assets/bvt3.jpg';

const Home = () => {
  return (
    <div className="w-full bg-white">
      {/* Hero */}
      <section className="relative w-full h-[80vh]">
        <Swiper
          modules={[Autoplay, EffectFade]}
          effect="fade"
          loop
          speed={4000}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          className="w-full h-full"
        >
          {[bvt1, bvt2, bvt3].map((img, idx) => (
            <SwiperSlide key={idx}>
              <img src={img} alt={`Slide ${idx + 1}`} className="w-full h-full object-cover brightness-[0.6] z-10" />
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 z-20">
          <p className="text-base md:text-lg mb-4 tracking-widest uppercase text-white/90">
            Reliability · Efficiency · Safety
          </p>
          <h1 className="text-4xl md:text-6xl font-bold mb-4">CJH Transportation</h1>
          <p className="text-lg md:text-xl max-w-2xl italic">
            No matter the load, <strong>We carry it.</strong>
          </p>
        </div>
      </section>

      {/* About Us */}
      <section className="py-12 px-6 bg-[#f9f9f9] text-center">
        <h2 className="text-3xl font-bold mb-4 text-[#003366]">About Us</h2>
        <p className="max-w-3xl mx-auto text-gray-700 text-lg leading-relaxed">
          CJH Transportation is a logistics and freight company based in Seattle, WA. We specialize in cargo transportation across the United States, delivering reliable and efficient service to meet the evolving needs of our clients.
        </p>
      </section>

      {/* Our Pillars */}
      <section className="py-10 px-6 text-center">
        <h3 className="text-2xl font-bold mb-10 text-[#003366]">Our Core Values</h3>
        <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8 text-left text-gray-700 text-sm leading-6">
          <div>
            <h4 className="text-lg font-semibold mb-2">Professionalism</h4>
            <p>Experienced drivers and logistics personnel committed to quality and precision.</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-2">Commitment</h4>
            <p>Every shipment is handled with responsibility, care, and on-time execution.</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-2">Trust</h4>
            <p>Long-term relationships with clients built on transparency and performance.</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-2">Resilience</h4>
            <p>Adaptability to challenges and continuity in every operation nationwide.</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-2">Innovation</h4>
            <p>We integrate modern logistics tools and tracking technologies into our workflow.</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-2">Partnership</h4>
            <p>Collaborations with suppliers and businesses that share our logistics standards.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
